import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { CampaignsService } from "../services/campaigns.service";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class CampaignResolver implements Resolve<any> {
  constructor(private campaignsService: CampaignsService) {}

  resolve(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const queryString = activatedRoute.queryParams;
    const campaignID = queryString.campaign ? queryString.campaign : "";
    return this.campaignsService.detail(campaignID);
  }
}